export default {
  name: 'recuperar',
  data() {
    return {
      email: '',
      loading: false,

    }
  },

  methods: {
    enviar() {

      if (this.email != '') {

        this.loading = true;
        this.$http
          .post('/config/recuperar/acceso', { email: this.email })
          .then(response => {
            alert(response.data)
            this.loading = false;
            window.location.href = '/#/'

          }).catch(response => {
            alert(`Se produjo un error al procesar la solicitud: ${response.response.data}`)
            this.loading = false;
          });

      } else {

        alert("Ingrese algún correo.")
      }

    },

  }
}



// WEBPACK FOOTER //
// ./src/components/recuperar/index.js